/**
 * Avatar initials for a display name, an email, or a username.
 *
 * Must stay a total function: it previously indexed with [0], and indexing an
 * empty string yields undefined, so a name carrying a double space ("Adrijan
 * Radj" with two spaces, which HTML renders collapsed and therefore looks fine)
 * produced the literal text "AUNDEFINED" in the avatar. Tokens are filtered
 * before use and read with charAt so no input can reach that state again.
 *
 * Lives apart from Auth.util so it stays free of the redux store import, which
 * pulls in axios and makes the module untestable under CRA's jest.
 */
export const getUserInitials = (name?: string | null) => {
  const tokens = (name ?? '')
    // An email's domain must not supply initials — otherwise
    // "adrijan@skyhighgrowth.com" takes its second letter from ".com".
    .split('@')[0]
    // Repo-sync users carry a trailing provider annotation, e.g.
    // "Ada Lovelace (GitHub)" - without stripping it, the last token
    // becomes "(GitHub)" and the initials come out as "A(" instead of "AL".
    .replace(/\s*\([^()]*\)\s*$/, '')
    .split(/[\s._]+/)
    .filter(Boolean);

  if (tokens.length === 0) return 'U';
  if (tokens.length === 1) return tokens[0].slice(0, 2).toUpperCase();

  // First and last token, so a middle name does not displace the surname.
  return (
    tokens[0].charAt(0) + tokens[tokens.length - 1].charAt(0)
  ).toUpperCase();
};
